type Props = {
  label?: string;
  id?: string;
  href?: string;
  className?: string;
  onClick?: () => void;
};

export default function ReferenceLink({
  label = "",
  id = "",
  href = "",
  className = "",
  onClick,
}: Props) {
  return (
    <a
      id={id}
      className={`my-1 rounded-full bg-neutral-500 px-2 py-1 text-xs text-white hover:bg-neutral-400 ${className} mr-2 transition-colors`}
      onClick={onClick}
      href={href}
      target="_blank"
      rel="noreferrer"
    >
      {label}
    </a>
  );
}
